module.exports = __webpack_public_path__ + "static/media/S3N4-5.cda004c9.svg";